import { defineNuxtPlugin, useRuntimeConfig, useRoute } from '#imports'

interface UserResponse {
  user: {
    id: number;
  } | null;
  organization?: {
    id: number;
    slug: string;
  }
}

declare global {
  interface Window {
    LogRocket?: {
      init: (id: string) => void;
      identify: (id: string, properties: Record<string, any>) => void;
    }
  }
}

export default defineNuxtPlugin(async (nuxtApp) => {
  // Only run on client-side
  if (process.server) return

  const config = useRuntimeConfig()
  const route = useRoute()
  const logRocketKey = config.public.logRocketKey

  // Don't proceed if LogRocket key isn't configured
  if (!logRocketKey) return

  // Load LogRocket script
  const script = document.createElement('script')
  script.src = 'https://cdn.lr-in.com/LogRocket.min.js'
  script.crossOrigin = 'anonymous'

  script.onload = async () => {
    try {
      // Check if user is authenticated
      const { data } = await useFetch<UserResponse>(`/api/${route.params.org_slug}/auth`, {
        headers: {
          Accept: 'application/json',
          'X-Api-Request': 'true'
        }
      })

      // Only initialize if we have authenticated user
      if (!data.value?.user) return

      window.LogRocket?.init(logRocketKey)
      window.LogRocket?.identify(data.value.user.id.toString(), {
        ...(data.value.organization ? {
          orgId: data.value.organization.id.toString(),
          orgSlug: data.value.organization.slug
        } : {}),
        releaseStage: config.public.appEnv || 'development',
        appUrl: window.location.origin
      })
    } catch (error) {
      console.error('Failed to initialize LogRocket:', error)
    }
  }

  document.head.appendChild(script)
})